import { css } from '@emotion/react';
import DisplayField from '../../../../components/DisplayField';
import HelpIcon from '../../../../components/HelpIcon';
import { useUserSessionContext } from '../../../../components/UserSessionContextWrapper';
import Footer from '../Footer';

function EmailView({ email, labels, onEdit }) {
    const { enableVeevaIdUsernameUpdate } = useUserSessionContext();

    return (
        <>
            <DisplayField
                css={css`
                    margin-bottom: 2.333rem;

                    label {
                        margin-bottom: 0.6667rem;
                    }
                `}
                label={
                    <div>
                        {labels.primaryEmailLabel}{' '}
                        <HelpIcon message={labels.usernameTooltipLabel} />
                    </div>
                }
            >
                {email}
            </DisplayField>
            {enableVeevaIdUsernameUpdate && (
                <Footer onSubmit={onEdit} submitLabel={labels.editLabel} />
            )}
        </>
    );
}

export default EmailView;
